
export const articleStyles = `
  /* ... keep existing code (h1, h2, h3, p styles) */
  .article-content h1 {
    font-size: 2rem;
    font-weight: bold;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
  .article-content h2 {
    font-size: 1.75rem;
    font-weight: bold;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
  .article-content h3 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
  .article-content p {
    margin-bottom: 1.25rem;
    line-height: 1.7;
  }
  .article-content ul, .article-content ol {
    margin-bottom: 1.25rem;
    padding-left: 1.5rem; /* Standard padding for lists */
  }

  /* Force list style types for article content */
  .article-content ul {
    list-style-type: disc !important;
  }
  .article-content ol {
    list-style-type: decimal !important;
  }

  .article-content li {
    margin-bottom: 0.5rem;
    display: list-item !important; /* Ensure li behaves as a list item */
  }

  /* Ensure list markers are visible in article content */
  .article-content ul > li::marker,
  .article-content ol > li::marker {
    color: hsl(var(--foreground)) !important;
  }
  /* ... keep existing code (blockquote, img, a, figure, figcaption, :after styles) */
  .article-content blockquote {
    border-left: 4px solid rgba(255, 255, 255, 0.2);
    padding-left: 1rem;
    font-style: italic;
    margin: 1.5rem 0;
  }
  .article-content img {
    max-width: 100%;
    height: auto;
    border-radius: 0.25rem;
    margin: 1.5rem 0;
  }
  .article-content a {
    color: #9b87f5;
    text-decoration: underline;
    transition: opacity 0.15s;
  }
  .article-content a:hover {
    opacity: 0.8;
  }
  
  .article-content figure {
    margin: 2rem 0;
    box-sizing: border-box;
  }
  
  .article-content figure[data-alignment="left"] {
    float: left;
    margin-right: 1.5rem;
    margin-bottom: 1rem;
    max-width: 50%;
  }
  
  .article-content figure[data-alignment="right"] {
    float: right;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
    max-width: 50%;
  }
  
  .article-content figure[data-alignment="center"] {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
  
  .article-content figcaption {
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    padding-top: 0.5rem;
    font-style: italic;
  }
  
  .article-content:after {
    content: "";
    display: table;
    clear: both;
  }
`;

